// MF-554 — Board Builder sections: the school's Boards and the Chart Library catalog.
import { Box, Tab, Tabs } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import BuilderGuide from './BuilderGuide'

const BuilderTabs = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const base = pathname.replace(/\/board-builder(\/.*)?$/, '/board-builder')
  const value = pathname.endsWith('/library') ? 'library' : 'boards'
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
      <Tabs
        value={value}
        onChange={(_, v) => navigate(v === 'library' ? `${base}/library` : base)}
        sx={{ minHeight: 36, '& .MuiTab-root': { minHeight: 36, textTransform: 'none', fontSize: 14 } }}
      >
        <Tab value='boards' label='Boards' />
        <Tab value='library' label='Chart Library' />
      </Tabs>
      <BuilderGuide />
    </Box>
  )
}

export default BuilderTabs
